import Inspector from './inspector';
import SvgComponent from './svgAccordion';
const { RichText, InnerBlocks } = wp.blockEditor;

export default ({ attributes, setAttributes }) => {
  const {
    variant,
    title,
    titleTag,
    padded,
    isParent,
    containerized,
    subtitle,
    color,
    textColor,
    hasMargin,
    border,
  } = attributes;

  const ALLOWED_BLOCKS = [
    'base/heading-sumicity',
    'base/paragraph-sumicity',
    'app/accordion-item',
    'app/card-sumicity',
    'app/table-sumicity',
    'app/divider-sumicity',
  ];

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <details
        className={`
        Accordion ${variant}
        ${isParent ? 'Accordion--parent' : 'Accordion--child'}
        ${containerized ? 'Container' : ''} ${border ? '' : 'borderBefore'}`}
      >
        <summary className={color}>
          <div
            className={`Accordion__heading  ${
              variant === 'default' ? textColor : ''
            } ${hasMargin ? '' : 'noPadding'}`}
          >
            <RichText
              tagName={titleTag}
              value={title}
              placeholder={`Título (tag ${titleTag})`}
              className="Acordion__title"
              onChange={(title) => setAttributes({ title })}
              withoutInteractiveFormatting
            />
            <span className={`Accordion__marker ${variant}`}>
              {variant == 'default' && <SvgComponent />}
            </span>
          </div>

          {variant == 'withDescription' && (
            <RichText
              tagName="p"
              value={subtitle}
              placeholder="Descrição (tag p)"
              className="Accordion__subtitle"
              onChange={(subtitle) => setAttributes({ subtitle })}
              withoutInteractiveFormatting
            />
          )}
        </summary>
        <div className={`Accordion__content ${!padded ? 'no-padding' : ''}`}>
          <InnerBlocks allowedBlocks={ALLOWED_BLOCKS} />
        </div>
      </details>
    </>
  );
};
